import { render, staticRenderFns } from "./ReAddBalance.vue?vue&type=template&id=6a5a7d3f&scoped=true"
import script from "./ReAddBalance.vue?vue&type=script&lang=js"
export * from "./ReAddBalance.vue?vue&type=script&lang=js"
import style0 from "./ReAddBalance.vue?vue&type=style&index=0&id=6a5a7d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a7d3f",
  null
  
)

export default component.exports